import { TextField } from '@dhl-ui/components'

import type { RenderProps } from '~/modules/ppp/components/renderers/types'
import { estimateLines } from '~/modules/ppp/helpers'

export const PlainRenderer = ({ value }: RenderProps) => (
  <TextField fullWidth multiline value={value} disabled rows={Math.min(30, estimateLines(value) + 1)} />
)
